/**
 * @param UTC: yyyy-MM-ddTHH:mm:ss.00Z
 * @returns JST: yyyy-MM-dd HH:mm:ss
 */
export const convertJST = (UTC: any) => {
  const _time = new Date(UTC);
  _time.setHours(_time.getHours() + 9);
  return _time.toISOString().split('T').join(' ').slice(0, -5);
};
